import { PopupActionTypes } from './actionTypes';
import type { PopupAction } from './actions';
import { PopupTypes } from './types';

export interface PopupState {
  openPopup: PopupTypes;
}

export const popupInitialState: PopupState = {
  openPopup: PopupTypes.NONE,
};

export const popupReducer = (state: PopupState = popupInitialState, action: PopupAction): PopupState => {
  if (!(action.type in PopupActionTypes)) {
    return state;
  }
  switch (action.type) {
    case PopupActionTypes.SET_OPENED_POPUP: {
      return {
        ...state,
        openPopup: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
